import { siteStats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="bg-primary-500">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {siteStats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-white mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}